import { KeyMetricChartDataPoint } from 'src/components/organisms/KeyMetricChart';

type TrendResult = {
  upOrDown: 'up' | 'down';
  upOrDownValue: string;
};

/**
 * Calculates trend direction and percentage change from time series data
 * @param points Array of time series points with value and utcEpoch
 * @returns Object with upOrDown direction and upOrDownValue percentage
 */
export const calculateTrendFromTimeSeries = (
  points: KeyMetricChartDataPoint[],
): TrendResult => {
  // Sort by utcEpoch to get chronological order
  const sortedPoints = points
    .filter((p) => typeof p?.value === 'number' && !Number.isNaN(p.value))
    .sort((a, b) => a.utcEpoch - b.utcEpoch);

  if (sortedPoints.length < 2) {
    return { upOrDown: 'up', upOrDownValue: '0%' };
  }

  const first = sortedPoints[0].value ?? 0;
  const last = sortedPoints[sortedPoints.length - 1].value ?? 0;
  const delta = last - first;
  const direction: 'up' | 'down' = delta >= 0 ? 'up' : 'down';
  const pct = first === 0 ? 0 : Math.round((delta / Math.abs(first)) * 100);

  return { upOrDown: direction, upOrDownValue: `${Math.abs(pct)}%` };
};
